import FacebookLogo from '../../assets/icons/fb.svg';
import WhatsappLogo from '../../assets/icons/whatsapp_logo.svg';
import TwitterLogo from '../../assets/icons/twitter.svg';
import LinkedinLogo from '../../assets/icons/linkedin.svg';
import {encodeUrl, TruncateTitle} from '../../utils/helper';
import {Button} from '../../ui-components/Button/button';
import {CopyIcon} from '../../ui-components/Iconpack';
import tracker from '../../lib/analytics/tracker';
import {EventNames, EventProperty} from '../../lib/analytics/events';
import {toast} from 'react-toastify';

interface SocialProps {
    imageUrl: string;
}
export default function SocialShare({imageUrl}: SocialProps) {
    const encodedImageUrl = encodeUrl(imageUrl);
    const landingUrl = `${window.location.origin.includes('localhost') ? 'https://staging.perceptpixel.com' : window.location.origin}/share?image=`;
    const copyText = (text: string) => navigator.clipboard.writeText(text);

    return (
        <div className='mb-[20px] flex flex-col items-center justify-center gap-8 md:flex md:flex-row'>
            <img src={encodedImageUrl} alt='shareimage' className='h-[282px] w-[196px] rounded-[12px] object-cover' />
            <div className='flex flex-col'>
                <span className='mb-5 text-[30px] font-[700] leading-[38px] text-[#000000]'>Share this Image</span>
                <span className='text-[20px] font-[400] leading-[30px] text-[#000000]'>Share link</span>
                <div className='mb-6 mt-4 hidden w-[770px] items-center justify-center rounded-[8px] bg-[#F2F4F7] md:flex'>
                    <span className='w-[115px] pl-5 text-[1rem] font-[700] text-[#0C111D]'>Image URL: </span>
                    <input
                        type='text'
                        className='w-[465px] rounded-[8px] bg-[#F2F4F7] py-[10px] text-[1rem] font-[400] text-[#0C111D]'
                        value={`${TruncateTitle(encodedImageUrl, 40)}`}
                        disabled
                    />
                    <Button
                        variant='nude'
                        className='text-[1rem] font-[700] text-[#155EEF]'
                        onClick={() => {
                            copyText(encodeUrl(encodedImageUrl)).then(() => {
                                tracker.trackEvent(EventNames.IMAGE_COPIED);
                                toast.success('Image Url Copied');
                            });
                        }}>
                        <CopyIcon height={24} width={24} color={'#155EEF'} />
                        Copy Image Url
                    </Button>
                </div>
                <div className='mb-6 mt-4 flex w-[280px] rounded-[8px] bg-[#F2F4F7] md:hidden'>
                    <input
                        type='text'
                        className='w-[465px] rounded-[8px] bg-[#F2F4F7] py-[10px] text-[1rem] font-[400] text-[#0C111D]'
                        value={`Image URL: ${TruncateTitle(encodedImageUrl, 40)}`}
                        disabled
                    />
                    <Button
                        variant='nude'
                        className='text-[1rem] font-[700] text-[#155EEF]'
                        onClick={() => {
                            copyText(encodeUrl(encodedImageUrl)).then(() => {
                                tracker.trackEvent(EventNames.IMAGE_COPIED);
                                toast.success('Image Url Copied');
                            });
                        }}>
                        <CopyIcon height={24} width={24} color={'#155EEF'} />
                    </Button>
                </div>
                <span className='text-[20px] font-[400] leading-[30px] text-[#000000]'>Share image</span>
                <div className='mt-[22px] flex gap-[14px]'>
                    <img
                        src={FacebookLogo}
                        alt='fb'
                        onClick={() => {
                            tracker.trackEvent(EventNames.SOCIAL_SHARE_CLICKED, {
                                [EventProperty.SharingPlatform]: 'Facebook',
                            });
                            window.open(
                                `https://www.facebook.com/sharer/sharer.php?u=${landingUrl}${encodedImageUrl}`,
                                '_blank',
                            );
                        }}
                        className='cursor-pointer'
                    />
                    <img
                        src={WhatsappLogo}
                        alt='whatsapp'
                        onClick={() => {
                            tracker.trackEvent(EventNames.SOCIAL_SHARE_CLICKED, {
                                [EventProperty.SharingPlatform]: 'Whatsapp',
                            });
                            window.open(`https://wa.me/?text=${landingUrl}${encodedImageUrl}`, '_blank');
                        }}
                        className='cursor-pointer'
                    />
                    <img
                        src={TwitterLogo}
                        alt='twitter'
                        onClick={() => {
                            tracker.trackEvent(EventNames.SOCIAL_SHARE_CLICKED, {[EventProperty.SharingPlatform]: 'X'});
                            window.open(
                                `https://twitter.com/intent/tweet?url=${landingUrl}${encodedImageUrl}`,
                                '_blank',
                            );
                        }}
                        className='cursor-pointer'
                    />
                    <img
                        src={LinkedinLogo}
                        alt='linkedin'
                        onClick={() => {
                            tracker.trackEvent(EventNames.SOCIAL_SHARE_CLICKED, {
                                [EventProperty.SharingPlatform]: 'LinkedIn',
                            });
                            window.open(
                                `https://www.linkedin.com/sharing/share-offsite/?url=${encodedImageUrl}`,
                                '_blank',
                            );
                        }}
                        className='cursor-pointer'
                    />
                </div>
            </div>
        </div>
    );
}
